Core.Contract = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/contract',

    defaults: function() { return {
        customerName: '',
        supplierName: '',
        title: null,
        description: null,
        customerAcceptedTimeStamp: null,
        customerDeletedTimeStamp: null,
        supplierAcceptedTimeStamp: null,
        supplierDeletedTimeStamp: null,
        token: null,
        toEmailAddress: null,
        replacesContractId: null,
        replacedByContractId: null,
        attestMode: 'INDEPENDENT',
        jobSupplierFields: null,    
        supplierInvoicingJobItems: false,
        supplierWorkReportTemplate: false,
        selectedSupplierWorkReportTemplateId: null,
        shareInternalInformationWithSupplier: false,
        shareScheduledUserEmailWithSupplier: false,
        shareScheduledUserPhoneWithSupplier: false,
        notifyOnNotes: false,
        notifyOnDiscrepancyNotes: false,
        notifyCustomerToSupplier: false,
        notifySupplierToCustomer: false
    }},

    replacement: function() {
        var re = this.clone();
        re.set({
            id: null,
            state: 'DRAFT',
            replacesContractId: this.id,
            replacedByContractId: null,
            customerDeletedTimeStamp: null,
            customerDeletedUserId: null,
            supplierDeletedTimeStamp: null,
            supplierDeletedUserId: null,
        });
        if (!this.isCustomer()) {
            re.set({
                customerAcceptedTimeStamp: null,
                customerAcceptedUserId: null,
            });
        }
        if (!this.isSupplier()) {
            re.set({
                supplierAcceptedTimeStamp: null,
                supplierAcceptedUserId: null,
            })
        }
        return re;
    },

    // actions

    claim: function(groupId) {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + (this.get('token') || this.id) + '/claim/' + groupId,
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
    },

    accept: function() {
		var self = this;
		return $.ajax({
			url: this.url() + '/accept',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});

    },

    // getters

    isCustomer: function() {
        return this.userIsCustomer(Core.client.me);
    },

    isSupplier: function() {
        return this.userIsSupplier(Core.client.me);
    },

    userIsCustomer: function(user) {
        if (user && user.getGroupMembership && this.get('customerGroupId'))
            return user.getGroupMembership(this.get('customerGroupId'));
        if (user && user.get('emailAddress') == this.get('toEmailAddress') && !this.get('customerGroupId'))
            return true;
        return false;
    },

    userIsSupplier: function(user) {
        if (user && user.getGroupMembership && this.get('supplierGroupId'))
            return user.getGroupMembership(this.get('supplierGroupId'));
        if (user && user.get('emailAddress') == this.get('toEmailAddress') && !this.get('supplierGroupId'))
            return true;
        return false;
    },

    isAccepted: function() {
        return this.get('state') == 'ACCEPTED' && this.get('customerAcceptedTimeStamp') && this.get('supplierAcceptedTimeStamp');
    },

    isValidForGroup: function(groupId) {
        return this.isValidForCustomerGroup(groupId) || this.isValidForSupplierGroup(groupId);
    },

    isValidForCustomerGroup: function(groupId) {
        if (groupId && typeof groupId == 'object') groupId = groupId.id;
        if (this.get('customerGroupId') == groupId) return true;
        var group = Core.client.groups.get(groupId);
        while (group) {
            if (group && group.get('parentGroupId') && this.get('customerGroupId') == group.get('parentGroupId')) return true;
            group = Core.client.groups.get(group.get('parentGroupId'));
        };
        return false;
    },

    isValidForSupplierGroup: function(groupId) {
        if (groupId && typeof groupId == 'object') groupId = groupId.id;
        if (this.get('supplierGroupId') == groupId) return true;
        var group = Core.client.groups.get(groupId);
        while (group) {
            if (group && group.get('parentGroupId') && this.get('supplierGroupId') == group.get('parentGroupId')) return true;
            group = Core.client.groups.get(group.get('parentGroupId'));
        };
        return false;
    },

});

Core.Contracts = Backbone.Collection.extend({
    model: Core.Contract,
    url: Core.contextRoot + '/contract',
});
